import { Header } from '@/components/Layout/Header/Header';
import { Tabs } from '@/components/Ui';
import { useSchools } from './schools.hook';
import SchoolList from '@/components/Views/SchoolList/SchoolList';
import SchoolProposalList from '@/components/Views/SchoolProposalList/SchoolProposalList';
import SchoolsStatistics from './SchoolsStats';
import { FadeLoader } from 'react-spinners';
import ValidateSchoolProposalForm from '@/components/Views/SchoolProposalList/ValidateSchoolProposalForm';

const Schools = () => {
  const {
    activeTab,
    setActiveTab,
    loadingStats,
    loadingSchools,
    loadingSchoolsProposals,
  } = useSchools();

  return (
    <div className="flex flex-col max-h-screen">
      <Header role="Admin" userName="Mas Aly" title="Gestion des écoles" />
      <ValidateSchoolProposalForm />
      {loadingStats ? (
        <div className="w-full h-[100vh] flex items-center justify-center">
          <FadeLoader color="#FEC200" />
        </div>
      ) : (
        <>
          <SchoolsStatistics />
          <div className="flex flex-col items-start justify-start gap-4">
            <Tabs
              activeIndex={activeTab}
              setActiveIndex={() => {
                setActiveTab((prev) => (activeTab === 0 ? prev + 1 : prev - 1));
              }}
              tabs={[
                { id: 1, title: 'Ecoles' },
                { id: 2, title: 'En attentes' },
              ]}
            />
            {loadingSchools || loadingSchoolsProposals ? (
              <div className="w-full h-[50vh] flex items-center justify-center">
                <FadeLoader color="#FEC200" />
              </div>
            ) : (
              <div className="w-full">
                {activeTab === 0 && <SchoolList />}
                {activeTab === 1 && <SchoolProposalList />}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Schools;
